import { $t } from '@/i18n';
import widget from './registration';

import TopSwitch from './switch/TopSwitch';
import EnvForm from './switch/EnvForm';

widget.register('switch', {
  name: $t('k_2c3885e7'),
  configComponent: null,
  viewComponent: TopSwitch,
});

widget.register('env', {
  name: $t('k_ac4e9d62'),
  configComponent: EnvForm,
  viewComponent: TopSwitch,
});

export default widget;
